import RescheduleBookingSection from "components/RescheduleBookingSection";
import { ContainerWrapper, PageWrapper, AlignWrapper, Align } from "./style";

const RescheduleBooking = () => {

  return (
    <>
      <div className="sixmeetings-content">
        <div className="sixmeetings-adss">
          <PageWrapper>
            <AlignWrapper>
              <Align>
                <ContainerWrapper>
                  <RescheduleBookingSection />
                </ContainerWrapper>
              </Align>
            </AlignWrapper>
          </PageWrapper>
        </div>
      </div>
    </>
  );
};
export default RescheduleBooking;